import { gql } from '../../../artifacts/gql';

export const getUnifiedUser = gql(`
  query webGetUnifiedUserQuery {
    unifiedUser {
      kycStatus
      tenantId
      frozen
      firstName
      lastName
      phone {
        number
        status
      }
      unifiedPhoneStatus {
        hasConflict
        livePhoneNumber {
          number
          status
        }
        collectPhoneNumber {
          number
          status
        }
      }
      username
      usernameUpdatedAt
      usernameEditableAfter
      country
      currency
      addresses {
        name
        line1
        line2
        city
        state
        postalCode
        country
        phone
        company
        id
        countryV2
      }
      chatToken
      email {
        address
        verified
      }
      vaultSubmissionAddress {
        addressLine1
        addressLine2
        city
        country
        name
        state
        zip
      }
      liveAttributes {
        id
        brazeExternalId
      }
      insertedAt
    }
  }
`);
